export default

class Collection {

    constructor( options ) {

        this.setOptions(options);
    }

    setOptions( options = {} ){

        this.data   = options.data    || [];
        this.links  = options.links   || {};
        this.meta   = options.meta    || {};
    }

    get(index){

        if(typeof this.data[index] !== undefined ){

            return this.data[index];
        }

        return null;
    }

    remove(index){

        if(typeof this.data[index] !== undefined ){

            return this.data.splice(index, 1);
        }

        return null;
    }

    [Symbol.iterator]() {

        // use index to track properties
        let index = 0;

        // get the properties of the object
        let properties = options.data;

        // set to true when the loop is done
        let done = false;

        // return the next method, need for iterator
        return {

            next: () => {

                done = ( index >= properties.length );
                // define the object you will return done state, value eg Lila ,key eg
                //name
                let obj = {
                    done: done, value:
                        this[properties[index]], key: properties[index]
                };
                // increment index
                index++;

                return obj;
            }
        };
    }

    load(page) {

        let self = this;
        let url  = null;
        if (!page) {
            page = 1;
        }

        Media.fetch(page, url).then(function(response){

            self.files = response;

        }, function(error){

            console.log(error);

        });
    }
}


// WEBPACK FOOTER //
// ./resources/js/models/Collection.js